/**
 * Created by lihanying on 2017/7/6.
 */
import { GETPERMISSION, GETCLUBLISTSUCCESS, GETCLUBINFO, GETWALLETINFO, GETWALLETRECORD } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETPERMISSION:
      return Object.assign({}, state, { permission: action.payload })
    case GETCLUBLISTSUCCESS:
      return Object.assign({}, state, { clubList: action.payload })
    case GETCLUBINFO:
      return Object.assign({}, state, { clubInfo: action.payload })
    case GETWALLETINFO:
      return Object.assign({}, state, { walletInfo: action.payload })
    case GETWALLETRECORD:
      return Object.assign({}, state, { walletRecord: action.payload })

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/ClubList/reduce.js